export default __webpack_public_path__ + "8ef381ce4affb715e8dc20daa77f5a35.png";